import { isEntitlementValueTruthy } from "utils/has-entitlement";

export type UserWithPlan = {
  plan?: string;
  role?: string;
  ugcLibraryAddon?: boolean;
  preferences?: {
    collectionUserCanAccess?: string[];
    entitlements?: Record<string, string | undefined>;
  };
  subscription?: {
    subscription?: {
      status?: string;
    };
  };
};

export function isFullLibrary(user?: UserWithPlan) {
  if (!user || !user.plan) {
    return false;
  }

  // Reverse trial → full library (every feature unlocked).
  if (user.subscription?.subscription?.status === "in_trial") {
    return true;
  }

  if (user.ugcLibraryAddon) {
    return true;
  }

  // Entitlement-first: editor-library covers full library access. Some
  // backends may also grant a dedicated "library-full" key — check both.
  // Use isEntitlementValueTruthy (shared with hasEntitlement) so any future
  // backend shape (`"1"`, `"yes"`, numeric strings) is handled consistently
  // with every other gate, rather than drifting from a literal `=== "true"`.
  const entitlements = user.preferences?.entitlements;
  if (isEntitlementValueTruthy(entitlements?.["editor-library"])) return true;
  if (isEntitlementValueTruthy(entitlements?.["library-full"])) return true;

  // Legacy plan-code fallback for non-migrated users.
  return [
    "essentials",
    "marketer",
    "professional",
    "agency",
    "enterprise",
    "custom",
  ].some((plan) => user.plan?.includes(plan));
}

export function isLibraryRestricted(user?: UserWithPlan) {
  return !isFullLibrary(user);
}

export function isCollaboratorLibraryRestricted(user?: UserWithPlan) {
  if (!user) {
    return false;
  }

  const role = user.role;
  const collectionUserCanAccess =
    user?.preferences?.collectionUserCanAccess || [];

  return role === "collaborator" && collectionUserCanAccess.length > 0;
}
